import { render, staticRenderFns } from "./LabelEditor.vue?vue&type=template&id=395bf206&scoped=true"
import script from "./LabelEditor.vue?vue&type=script&lang=js"
export * from "./LabelEditor.vue?vue&type=script&lang=js"
import style0 from "./LabelEditor.vue?vue&type=style&index=0&id=395bf206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395bf206",
  null
  
)

export default component.exports